import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { domToPng, filterNode } from "~utils/screenshot"

const ViewShot = forwardRef<
  { capture: (options?: { format?: string; quality?: number }) => Promise<string> },
  {
    children?: React.ReactNode
    options?: { format?: string; quality?: number; fileName?: string }
    style?: React.CSSProperties
    className?: string
  }
>(function ViewShot({ children, options: _options, style, className }, ref) {
  const nodeRef = useRef<HTMLDivElement>(null)

  useImperativeHandle(ref, () => ({
    capture: async () => {
      const node = nodeRef.current
      if (!node) return ""
      try {
        return await domToPng(node, { quality: 1, filter: filterNode })
      } catch {
        return ""
      }
    },
  }))

  return (
    <div ref={nodeRef} className={className} style={style}>
      {children}
    </div>
  )
})

export default ViewShot
